import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { NSDiversionsConstants } from '@ruby/configs/diversions.constants';
import { IGridConfigurations } from '@ruby/shared/models/commons/grid.interface';
import { IDiversionsPreviousRequest } from '@ruby/shared/models/diversions/diversions.interface';

@Component({
  selector: 'ng-previous-requests',
  templateUrl: './previous-requests.component.html',
  styleUrls: ['./previous-requests.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PreviousRequestsComponent {
  @Input() submittedDiversions!: Array<IDiversionsPreviousRequest>;
  @Input() loading!: boolean;
  configs: IGridConfigurations = NSDiversionsConstants.previousRequestsGridConfigs;

  constructor() { }
}
